var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRobot = function SvgRobot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 169 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.186 139.13v-5H94.387v39.799h49.732v-19.933h-9.933V139.13ZM74.598 139.13v-5H44.732v9.933h-9.933v29.866H84.53v-19.933h-9.933V139.13Z",
    fill: "currentColor",
    stroke: "#252525",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M139.124 124.197h-5V144.135H164V124.197h-24.876ZM29.862 64.598h-5v79.531h29.866v-79.53H29.862Z",
    fill: "currentColor",
    stroke: "#252525",
    strokeWidth: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.662 64.598h-5v59.665h109.331V64.598H59.663ZM10 64.598H5v59.665h19.933V64.598H10Z",
    fill: "currentColor",
    stroke: "#252525",
    strokeWidth: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.056 64.665h5V5H44.726v59.665h104.33Z",
    fill: "currentColor",
    stroke: "#252525",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.925 5h-5v59.665h29.866V5H19.925Z",
    fill: "currentColor",
    stroke: "#252525",
    strokeWidth: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 20v20M124 20v20M89.5 45h20M69.5 84.5H144V109",
    stroke: "#252525",
    strokeWidth: 10
  })));
};
export default SvgRobot;